import axios from "axios";

const paymentsBffConfig = {
  baseURL: import.meta.env.VITE_GLOBAL_PAYMENTS_BFF_BASE_URL,
  apiKey: import.meta.env.VITE_GLOBAL_PAYMENTS_BFF_API_KEY,
};

const paymentsBffApi = axios.create({
  baseURL: paymentsBffConfig.baseURL,
});

paymentsBffApi.interceptors.request.use((config) => {
  config.headers["x-api-key"] = paymentsBffConfig.apiKey;

  return config;
});

const mondayHookApi = axios.create({
  baseURL: import.meta.env.VITE_GLOBAL_PABBLY_BASE_URL
});

export { paymentsBffApi, mondayHookApi };
